import { render, staticRenderFns } from "./add-certificate-reason.vue?vue&type=template&id=2dc63971&scoped=true"
import script from "./add-certificate-reason.vue?vue&type=script&lang=js"
export * from "./add-certificate-reason.vue?vue&type=script&lang=js"
import style0 from "./add-certificate-reason.vue?vue&type=style&index=0&id=2dc63971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc63971",
  null
  
)

export default component.exports